import {Injectable } from '@angular/core';

@Injectable()
export class SearchService {

    public searchFilter(inputs, filterValues, filterFields, excludeNullField: boolean = false, fullMatch: boolean = false) {
        return this._searchFilter(inputs, filterValues, filterFields, [], [], '', [], fullMatch, false, false, false, excludeNullField);
    }

    public searchFilterWithRelated(inputs, filterValues, filterFields, relatedFields, excludeNullField: boolean = false) {
        return this._searchFilter(inputs, filterValues, filterFields, [], relatedFields, '', [], false, false, false, false, excludeNullField);
    }

    public searchFilterWithFunction(inputs, filterValues, filterFields, filterFunctionFields, excludeNullField: boolean = false) {
        return this._searchFilter(inputs, filterValues, filterFields, filterFunctionFields, [], '', [], false, false, false, false, excludeNullField);
    }

    public searchDateFilter(inputs, filterValues, filterFields, excludeNullField: boolean = false) {
        return this._searchFilter(inputs, filterValues, filterFields, [], [], '', [], false, false, true, false, excludeNullField);
    }

    public searchRangeDateFilter(inputs, filterValues, filterFields, excludeNullField: boolean = false) {
        return this._searchFilter(inputs, filterValues, filterFields, [], [], '', [], true, true, true, false, excludeNullField);
    }

    public searchRangeDateFilterWithRelated(inputs, filterValues, filterFields, relatedFields, excludeNullField: boolean = false) {
        return this._searchFilter(inputs, filterValues, filterFields, [], relatedFields, '', [], true, true, true, false, excludeNullField);
    }

    public searchRangeDateTimeFilter(inputs, filterValues, filterFields, excludeNullField: boolean = false) {
        return this._searchFilter(inputs, filterValues, filterFields, [], [], '', [], true, true, false, true, excludeNullField);
    }

    public searchRangeDateTimeFilterWithRelated(inputs, filterValues, filterFields, relatedFields, excludeNullField: boolean = false) {
        return this._searchFilter(inputs, filterValues, filterFields, [], relatedFields, '', [], true, true, false, true, excludeNullField);
    }

    public searchRangeFilter(inputs, filterValues, filterFields, excludeNullField: boolean = false) {
        return this._searchFilter(inputs, filterValues, filterFields, [], [], '', [], true, true, false, false, excludeNullField);
    }

    private _searchFilter(inputs, filterValues, filterFields, filterFunctionFields, relatedFields, excludedValues, excludedFields, fullMatch, rangeFilter, isDate, isDateTime, excludeNullField) {
        if (filterValues === undefined || filterValues === null || filterValues === '') {
            return inputs;
        }

        const output = [];
        for (const input of inputs) {
            let isToFilter = true;
            for (let j = 0; j < excludedFields.length; j++) {
                if (input[excludedFields[i]] != null) {
                    if (excludedValues instanceof Array) {
                        for (const excludedValue of excludedValues) {
                            isToFilter = isToFilter && (this._normalize(input[excludedFields[j]], isDate, isDateTime).indexOf(this._normalize(excludedValue, isDate, isDateTime)) === -1);
                        }
                    } else {
                        isToFilter = isToFilter && (this._normalize(input[excludedFields[j]], isDate, isDateTime).indexOf(this._normalize(excludedValues, isDate, isDateTime)) === -1);
                    }
                }

            }

            if (isToFilter) {
                var currentValues = [];
                for (var i = 0; i < filterFields.length; i++) {
                    currentValues.push(input[filterFields[i]]);
                }
                for (var i = 0; i < filterFunctionFields.length; i++) {
                    currentValues.push(input[filterFunctionFields[i]]());
                }
                for (var i = 0; i < relatedFields.length; i++) {
                    if(input[relatedFields[i]] instanceof Array) {
                        for(var k = 0; k < input[relatedFields[i]].length; k++) {
                            for(var j = 0; j < filterFields.length; j++) {
                                currentValues.push(input[relatedFields[i]][k][filterFields[j]])
                            }
                        }
                    }
                }

                for (var i = 0; i < currentValues.length; i++) {
                    if (currentValues[i] != null) {
                        var currValue = this._normalize(currentValues[i], isDate, isDateTime);
                        if (filterValues instanceof Array) {
                            var isValid = false;
                            if (!rangeFilter) {
                                for (var filterValue of filterValues) {
                                    isValid = isValid || (fullMatch ? currValue === this._normalize(filterValue, isDate, isDateTime) : currValue.indexOf(this._normalize(filterValue, isDate, isDateTime)) !== -1);
                                }
                            } else {
                                // Assumo che in filterValues[0] ci sia lo start e in filterValues[1] ci sia lo stop
                                if (fullMatch) {
                                    var currVal = currValue;
                                } else {
                                    var currVal = currValue.substring(parseInt(filterValues[2]), parseInt(filterValues[3]));
                                }
                                if (filterValues[0] && filterValues[0] !== '' && filterValues[1] && filterValues[1] !== '') {
                                    isValid = currVal >= this._normalize(filterValues[0], isDate, isDateTime) && currVal <= this._normalize(filterValues[1], isDate, isDateTime);
                                } else if (filterValues[0] && filterValues[0] !== '') {
                                    isValid = currVal >= this._normalize(filterValues[0], isDate, isDateTime);
                                } else if (filterValues[1] && filterValues[1] !== '') {
                                    isValid = currVal <= this._normalize(filterValues[1], isDate, isDateTime);
                            } else {
                                    isValid = true;
}
                            }

                            if (isValid) {
                                output.push(input);
                                break;
                            }
                        } else {
                            if (fullMatch ? currValue === this._normalize(filterValues, isDate, isDateTime) : currValue.indexOf(this._normalize(filterValues, isDate, isDateTime)) !== -1) {
                                output.push(input);
                                break;
                            }
                        }
                    } else {
                        if (!excludeNullField) {
                            output.push(input);
                        }
                    }

                }
            } else {
                output.push(input);
            }

        };
        return output;
    };

    private _normalize(field: any, isDate: boolean, isDateTime: boolean) {
        if (isDate) {
            return this._convertDate(field).toLowerCase();
        }
        if (isDateTime) {
            return this._convertDateTime(field).toLowerCase();
        }

        return field.toString().toLowerCase();
    }

    private _convertDate(inputFormat) {
        function pad(s) { return (s < 10) ? '0' + s : s; }
        if (inputFormat instanceof Date) {
            var d = new Date(inputFormat);
            return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('/');
        } else {
            // TODO prima o poi sistemare questa porcheria
            // Non posso convertire la stringa come data perchè prende il formato americano e inverte mese e giorno
            // e non c'è un Date.parse che accetta un formatter
            return inputFormat.substring(6, 10) + "/" + inputFormat.substring(3, 5) + "/" + inputFormat.substring(0, 2);
        }

    }

    private _convertDateTime(inputFormat) {
        function pad(s) { return (s < 10) ? '0' + s : s; }
        if (inputFormat instanceof Date) {
            var d = new Date(inputFormat);
            return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('/') + " " + [pad(d.getHours()), pad(d.getMinutes()), pad(d.getSeconds())].join(':');
        } else {
            // TODO prima o poi sistemare questa porcheria
            // Non posso convertire la stringa come data perchè prende il formato americano e inverte mese e giorno
            // e non c'è un Date.parse che accetta un formatter
            return inputFormat.substring(6, 10) + "/" + inputFormat.substring(3, 5) + "/" + inputFormat.substring(0, 2) + " " + inputFormat.substring(11, 19);
        }

    }
}
